import { create } from "zustand";
import type { ScheduleAction } from "@/api/types";

interface WeeklySelectionState {
    runId: string | null;
    action: ScheduleAction | null;
    activeDestinyIds: string[];
}

interface WeeklySelectionActions {
    setSelection: (payload: {
        runId: string;
        action: ScheduleAction | null;
        activeDestinyIds: string[];
    }) => void;
    clear: () => void;
}

export const useWeeklySelection = create<WeeklySelectionState & WeeklySelectionActions>((set) => ({
    runId: null,
    action: null,
    activeDestinyIds: [],

    setSelection: ({ runId, action, activeDestinyIds }) => {
        set({
            runId,
            action,
            activeDestinyIds,
        });
    },

    clear: () => {
        set({
            runId: null,
            action: null,
            activeDestinyIds: [],
        });
    },
}));
